(function($) {

var pageId = 'page-completed-todos',
	page = '#' + pageId;

$( function() {
	$('body').on('change', page + ' #select-member', function(e) {
		location.href = location.pathname + "?by_member=" + $(this).val();
	});
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.scrollLoad($page, function( loadBtn ) {
        return $.ajax({
            url: location.pathname,
            method: 'GET',
            dataType: "html",
            data: {
                till: $( ".day:last" ).attr( "data-date" ),
                by_member: $( "#select-member" ).val()
            },
            success: function( result ) {
                if ( result ) {
                    loadBtn.before( result );
                }
            }
        });
    });
});


})(jQuery);
